async function toggleAutoship(toggle) {
  console.log("> toggle: " + toggle)
  let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]

  if(toggle === false ) {
    autoship_element.classList.remove("selected")
    window.side_autoship = false
    await enableAutoship(false)
  } else {
    autoship_element.classList.add("selected")
    window.side_autoship = true
    await enableAutoship(true)
  }
}

async function enableAutoship(toggle) {

  const drawer = document.getElementById('cart-drawer')
  const loader = document.createElement("div")
  loader.classList.add('cart-loader')
  loader.id = "cart-loader"
  loader.innerHTML = `<i class="fas fa-spinner fa-spin" style="background-color:rgba(255, 255, 255, 0.3)"></i>`
  drawer.append(loader)  
  
  let response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    }
  })

  let cart = await response.json()
  console.log(cart)

  if (cart.items.length === 0) {
    let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]
    let autoship_checkbox = document.querySelector(".mo-side-autoship input")

    autoship_element.classList.remove("selected")
    autoship_checkbox.checked = false
    loader.remove()
    return
  }
  
  if (toggle) {

    let items = []

    for (let x = 0; x < cart.items.length; x++) {
      let item = cart.items[x]
      if (!gift_ids.includes(item.id)) {
        
        let product_reponse = await fetch(window.Shopify.routes.root + 'products/' +item.handle + '.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })  

        let product = await product_reponse.json()

        console.log("> looking for selling plans")
        console.log(product)
        if (product.selling_plan_groups.length > 0) {
          console.log("> " + product.handle + " has seeling plans")
          if (item.selling_plan_allocation !== undefined) {
            change_line = {
              line: x+1,
              quantity: item.quantity,
              selling_plan: item.selling_plan_allocation.selling_plan.id
            };
          } else {
            change_line = {
              line: x+1,
              quantity: item.quantity,
              selling_plan: 405504261
            };
          }
          items.push(change_line)
        }
      }
    }

    if (items.length > 0) {
      for (let z = 0; z < items.length; z++) {
        console.log("> updating..")
        console.log(items[z])
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(items[z])
        })
      }

      await loadEgCartDrawer()
      loader.remove()
    } else {
      let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]
      let autoship_checkbox = document.querySelector(".mo-side-autoship input")

      autoship_element.classList.remove("selected")
      autoship_checkbox.checked = false
      loader.remove()
    }
    
  } else {

    let items = []

    for (let x = 0; x < cart.items.length; x++) {
      let item = cart.items[x]
      if (!gift_ids.includes(item.id)) {
        
        let product_reponse = await fetch(window.Shopify.routes.root + 'products/' +item.handle + '.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })  

        let product = await product_reponse.json()

        console.log("> looking for selling plans")
        console.log(product)
        if (product.selling_plan_groups.length > 0) {
          console.log("> " + product.handle + " has seeling plans")
          if (item.selling_plan_allocation !== undefined) {
            change_line = {
              line: x+1,
              quantity: item.quantity,
              selling_plan: null
            };
          } else {
            change_line = {
              line: x+1,
              quantity: item.quantity,
              selling_plan: null
            };
          }
          items.push(change_line)
        }
      }
    }

    if (items.length > 0) {
      
      for (let z = 0; z < items.length; z++) {
        console.log("> updating..")
        console.log(items[z])
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(items[z])
        })
      }
      await loadEgCartDrawer()
      loader.remove()
    } else {
    let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]
    let autoship_checkbox = document.querySelector(".mo-side-autoship input")

    autoship_element.classList.remove("selected")
    autoship_checkbox.checked = false
    loader.remove()
  }

  }
}

async function checkSideAutoship() {

    //console.log(".............checkSideAutoship")
    let cart = await checkCart()
    let autoship = false
    let can_autoship = false

    if (cart.items.length === 0 ) return

    for(let i=0; i< cart.items.length; i++) {
      //console.log(gift_ids)
      if (!gift_ids.includes(cart.items[i].product_id)) {
        //console.log("->")
        //console.log(cart.items[i])

        let product_reponse = await fetch(window.Shopify.routes.root + 'products/' +cart.items[i].handle + '.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })  

        let product = await product_reponse.json()

        if (product.selling_plan_groups.length > 0) {
          can_autoship = true
        }
        if (product.selling_plan_groups.length > 0 && cart.items[i].selling_plan_allocation === undefined) {
          autoship = false
          break;
        } else if (product.selling_plan_groups.length > 0 && cart.items[i].selling_plan_allocation !== undefined) { 
          //console.log("--> " + product.id)
          autoship = true
        }
      }
    }

    let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]

    if(can_autoship) {
      autoship_element.style.display = "block"
    } else {
      autoship_element.style.display = "false"
    }

    if(autoship) {
      //console.log("---> autoship")
      element = document.querySelector('.mo-side-autoship .mo-subscribe')
      
      element.checked = true
      autoship_element.classList.add("selected")
      window.side_autoship = true
    }
}

window.addEventListener("DOMContentLoaded", async function () {
  checkSideAutoship()
})

window.addEventListener('click', async function (e){
  if(e.target.id === "drawer-checkout-button-autoship") {
    e.target.innerHTML = `<i style="font-size: 20px;" class="fas fa-spinner fa-spin"></i>`
    setTimeout(() => {
        e.target.innerHTML = "CHECKOUT"
    }, 5000)

    await checkOnetimeItem()
  }
})


/***** autoship mo_modal */

var mo_modal = document.getElementById("mo-autoship-popup");
var mo_modal_atc = document.getElementById("mo-autoship-popup-atc");
var btn = document.getElementById("myBtn");
var close_span = mo_modal.getElementsByClassName("close")[0];
var btn_no = mo_modal.getElementsByClassName("mo-no")[0];
var btn_yes = mo_modal.getElementsByClassName("mo-yes")[0];


async function autoship_popup_open() {
  
  let calculate_object = await calculate_autoship_saving()
  if (calculate_object === null) { return }
  let savings = parseFloat(calculate_object.total_saving)
  if (countDecimals(savings) > 0) { savings = savings.toFixed(2) }

  let text = ""
  let mo_save = document.getElementsByClassName("mo-save")[0]

  /*
  if (element.checked === false) {
    text = "You’re saving <span>$" + savings + "</span> on this order with"
    window.side_autoship = false
  } else {
  */
  text = "Save <span>$" + savings + "</span> on this order by switching to"
  window.side_autoship = true
  //}

  /*
  if (calculate_object.contains_protein) { collagen_copy.style.display = "list-item" }
  else { collagen_copy.style.display = "none" }
  */
  mo_save.innerHTML = text
  mo_modal.style.display = "block";
}

function autoship_activate(element) {
  let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]

  if (element.checked === false) {
    autoship_element.classList.remove("selected")
  } else {
    autoship_element.classList.add("selected")
  }
}

function autoship_popup_escape() {
  console.log("> fn: autoship_popup_escape")
  let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]
  let autoship_checkbox = document.querySelector(".mo-side-autoship input")

  if (window.side_autoship) {
    autoship_element.classList.remove("selected")
    autoship_checkbox.checked = false
    window.side_autoship = false
    mo_modal.style.display = "none";
  } else {
    autoship_element.classList.add("selected")
    window.side_autoship = true
    autoship_checkbox.checked = true
    mo_modal.style.display = "none";
  }
}

function autoship_popup_close() {

  console.log("> fn: autoship_popup_close")
  let autoship_element = document.getElementsByClassName("mo-side-autoship")[0]
  //let autoship_checkbox = document.querySelector(".mo-side-autoship input")

  mo_modal.style.display = "none";
  
  if (window.side_autoship) {
    autoship_element.classList.add("selected")
    toggleAutoship(true)
  } else {
    autoship_element.classList.remove("selected")
    toggleAutoship(false)
  }
}

function countDecimals (value) {
  if (Math.floor(value) !== value)
    return value.toString().split(".")[1].length || 0; 
  return 0;
}

async function autoship_popup_open_checkout(savings) {
  
  console.log("savings")
  console.log(savings)
  savings = parseFloat(savings)
  if (countDecimals(savings) > 0) { savings = savings.toFixed(2) }

  let text = ""
  let mo_save = document.getElementsByClassName("mo-save")[0]

  text = "Save <span>$" + savings + "</span> on this order by switching to"
  window.side_autoship = true

  mo_save.innerHTML = text
  mo_modal.style.display = "block";
}

async function checkOnetimeItem() {

  console.log("checkOnetimeItem()")
  let has_one_time_items = false
  let total_saving = 0
  let saving = 0
  let response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    }
  })

  let cart = await response.json()

  for (let j = 0; j < cart.items.length; j++) {
    let item = cart.items[j]
    if (item.selling_plan_allocation !== undefined) {
      console.log("selling_plan_allocation exists")
      console.log(item.selling_plan_allocation)
      continue
    }
    
    let product_reponse = await fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    let product = await product_reponse.json()
    saving = 0

    if (product.selling_plan_groups.length > 0) {
      has_one_time_items = true
      
      let i = 0
      product.variants.forEach(variant => {
        if (variant.id == item.variant_id) {
          selected_variant_index = i
        }
        i++
      });
      console.log(product)
      saving = item.price - product.variants[selected_variant_index].selling_plan_allocations[0].per_delivery_price
      saving = saving * item.quantity

      console.log("> " + item.handle + "  |  price: " + item.price + "  |  subscription : " + product.variants[selected_variant_index].selling_plan_allocations[0].per_delivery_price)
      console.log("> quantity: " + item.quantity)
      console.log("> saving: " + saving)
    }
    total_saving += saving;
  }

  total_saving = (total_saving / 100).toFixed(2)

  console.log("> total_saving: " + total_saving)
  
  if (has_one_time_items && window.Shopify && window.Shopify.country == 'US') {
    await autoship_popup_open_checkout(total_saving)
  } else {
    window.location.href = "/checkout"
  }
}

async function calculate_autoship_saving() {
  let response = await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    }
  })

  let cart = await response.json()
  let total_saving = 0
  let contains_protein = false

  console.log(cart.items)

  if (cart.items.length === 0) {
    let autoship_checkbox = document.querySelector(".mo-side-autoship input")
    autoship_checkbox.checked = false
    return null
  }

  let selling_plans_exist = false

  for (let j = 0; j < cart.items.length; j++){
    let item = cart.items[j]
    if (item.handle.includes('collagen-protein')) { contains_protein = true }
    //console.log(item)
    let product_reponse = await fetch(window.Shopify.routes.root + 'products/' +item.handle + '.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })  

    let product = await product_reponse.json()
    let selected_variant_index = 0
    let saving = 0

    //console.log(product)
    let i = 0
    if (product.selling_plan_groups.length > 0) {
      selling_plans_exist = true
      product.variants.forEach(variant => {
        if (variant.id == item.variant_id) {
          selected_variant_index = i
        }
        i++
      });
      saving = product.variants[selected_variant_index].price - product.variants[selected_variant_index].selling_plan_allocations[0].per_delivery_price
      saving = saving * item.quantity

      console.log("> " + item.handle + "  |  price: " + product.variants[selected_variant_index].discounted_price + "  |  subscription : " + product.variants[selected_variant_index].selling_plan_allocations[0].per_delivery_price)
      console.log("> saving: " + saving)
    }
    total_saving += saving;
  }

  if (!selling_plans_exist) {
    let autoship_checkbox = document.querySelector(".mo-side-autoship input")
    autoship_checkbox.checked = false
    return null
  }

  total_saving = (total_saving / 100).toFixed(2)
  
  if (total_saving < 1) { total_saving = 0 }
  console.log(">total_saving: " + total_saving)
  console.log("contains_protein: " + contains_protein)
  return {
    "total_saving": total_saving,
    "contains_protein": contains_protein
  }
}

close_span.onclick = function () {
  window.location.href = "/checkout"
  //autoship_popup_escape();
}

btn_no.onclick = function () {
  window.location.href = "/checkout"
  //autoship_popup_escape();
}

btn_yes.onclick = async function () {
  await toggleAutoship(true)
  window.location.href = "/checkout"
  //autoship_popup_close();
}

window.onclick = function (event) {
  console.log("> fn: window.click")
  if (event.target == mo_modal) {
    /*
    mo_modal.style.display = "none";
    mo_modal_atc.style.display = "none";
    */
    window.location.href = "/checkout"
  }
}

async function AutoshipAdd(element) {
  let autoship_checkbox = document.querySelector(".mo-side-autoship input")
  let subscribed_price = element.dataset.sprice

  if (subscribed_price > 0 && autoship_checkbox.checked ) {
    await addSingleItem(element, true)
  } else {
    await addSingleItem(element, false)
  }
}

async function autoship_popup_open_atc(savings, item, protein) {

  let checkbox = document.querySelector(".mo-side-autoship .mo-toggle input")
  let atc_mo_modal = document.getElementById("mo-autoship-atc-popup");
  let mo_save = document.querySelector("#mo-autoship-atc-popup .mo-save")
  let collagen_copy = document.querySelector("#mo-autoship-atc-popup .mo-autoship-collagen-copy")
  let close_btn = document.querySelector("#mo-autoship-atc-popup .close");

  let yes_btn = document.querySelector("#mo-autoship-atc-popup .mo-yes")
  let no_btn = document.querySelector("#mo-autoship-atc-popup .mo-no")

  /*
  if (checkbox.checked === true) {
    text = "You’re saving <span>$" + savings + "</span> on this order with"
    window.side_autoship = false
  } else {
  */
  text = "Save <span>$" + savings + "</span> on this order by switching to"
  window.side_autoship = true
  //}

  /*
  if (protein) { collagen_copy.style.display = "list-item" }
  else { collagen_copy.style.display = "none" }
  */
  mo_save.innerHTML = text

  yes_btn.onclick = async function () { await addSingleItem(item, true) }
  no_btn.onclick = async function () { await addSingleItem(item, false) }
  close_btn.onclick = function () { hide_mo_modal_atc() }
  atc_mo_modal.style.display = "block";
}

async function addSingleItem(atc, subscribe) {
  console.log("> addSingleItem(atc, subscribe)")
  let formData = {}
  let subscribe_toggle_handler = false

  try {
    subscribe_toggle_handler = subscribe_toggle
  } catch (error) {
    console.log(error)
  }

  if ((subscribe_toggle_handler || subscribe) && atc.dataset.sellingplanid > 0 )
  {
    formData = {
      'items': [{
        'id': atc.dataset.variantid,
        'selling_plan' :atc.dataset.sellingplanid,
        'quantity': 1
      }]
    }
  } else {
    formData = {
      'items': [{
        'id': atc.dataset.variantid,
        'quantity': 1
      }]
    }
  }
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
      console.log('attempted post request')
      const product = {
        'featured_image': atc.dataset.pimage,
        'title1': atc.dataset.ptitle1,
        'title2': atc.dataset.ptitle2
      }
      hide_mo_modal_atc()
      loadEgCartDrawerNotification([product])
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}

function hide_mo_modal_atc() {
  let atc_mo_modal = document.getElementById("mo-autoship-atc-popup");
  atc_mo_modal.style.display = "none"
}